import { Avatar, Box, Link, Typography } from "@mui/material";
import { Image, UserCircle2 } from "lucide-react";
import { useState } from "react";
import { useTheme } from "../../common/contexts/ThemeContext";

export const SourceHeader = ({ source }) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const { colors } = useTheme();
  const descriptionLimit = 205;

  const truncatedDescription =
    source.description?.length > descriptionLimit
      ? source.description.substring(0, descriptionLimit) + "..."
      : source.description;

  return (
    <Box sx={{ width: "100%" }}>
      {/* Cover/Banner Image (Thumbnail) */}
      <Box
        sx={{
          width: "100%",
          height: 200,
          backgroundImage: source.thumbnail
            ? `url(${source.thumbnail})`
            : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "8px 8px 0 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!source.thumbnail && (
          <Image size={80} style={{ color: "rgba(255,255,255,0.3)" }} />
        )}
      </Box>

      {/* Channel Info Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          py: 3,
          borderRadius: "0 0 8px 8px",
        }}
      >
        {/* Profile Picture (Avatar) */}
        <Box
          sx={{
            flexShrink: 0,
          }}
        >
          {source.avatar ? (
            <Avatar
              src={source.avatar}
              alt={source.account_name || "Source avatar"}
              sx={{
                width: 160,
                height: 160,
                border: "4px solid white",
              }}
            />
          ) : (
            <Avatar
              sx={{
                width: 160,
                height: 160,
                bgcolor: colors.secondary,
                border: "4px solid white",
                boxShadow: 3,
              }}
            >
              <UserCircle2
                size={100}
                style={{ color: colors.text.secondary }}
              />
            </Avatar>
          )}
        </Box>

        {/* Channel Details */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h1" sx={{ mb: 0.5 }}>
            {source.account_name || "Unknown Source"}
          </Typography>
          <Typography variant="bodyMd" component="p">
            {source.platform
              ? `${source.platform.charAt(0).toUpperCase() + source.platform.slice(1)}`
              : ""}{" "}
            · {source.imported_video_count || 0} assets
          </Typography>
          {source.description && (
            <Box>
              <Typography variant="bodyMd" component="span">
                {showFullDescription
                  ? source.description
                  : truncatedDescription}
              </Typography>
              {source.description.length > descriptionLimit && (
                <>
                  {" "}
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => setShowFullDescription(!showFullDescription)}
                    sx={{
                      cursor: "pointer",
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    {showFullDescription ? "show less" : "...more"}
                  </Link>
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
